// extracted by mini-css-extract-plugin
export default {"social":"styles_social__gZXew","socialLogo":"styles_socialLogo__x+Iq3"};